export var MAX_IMAGE_SIZE = 6000;
export var MIN_IMAGE_SIZE = 1;
//# sourceMappingURL=limitImage.constants.js.map